export default __webpack_public_path__ + "static/ActionCardSmallAnnotated-90524b0d2c0a80d877aee54a054318aa.png";